/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResidualRiskLabel
 */
export interface ResidualRiskLabel {
  /**
   *
   * @type {number}
   * @memberof ResidualRiskLabel
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof ResidualRiskLabel
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof ResidualRiskLabel
   */
  order?: number;
}

/**
 * Check if a given object implements the ResidualRiskLabel interface.
 */
export function instanceOfResidualRiskLabel(value: object): value is ResidualRiskLabel {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function ResidualRiskLabelFromJSON(json: any): ResidualRiskLabel {
  return ResidualRiskLabelFromJSONTyped(json, false);
}

export function ResidualRiskLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResidualRiskLabel {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    order: json['order'] == null ? undefined : json['order'],
  };
}

export function ResidualRiskLabelToJSON(value?: Omit<ResidualRiskLabel, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    order: value['order'],
  };
}
